import { Typography } from '@mui/material';

type INorecordsComponent = {
    styles?: any;
};
export const NoRecordsComponent = (props: INorecordsComponent) => {
    const { styles } = props;
    return <Typography sx={styles}>No Records</Typography>;
};
